<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">block</i>
      <h1 class="headline">Revocations are not allowed.</h1>
      <p>
        Revocations have been disabled for this meeting.
      </p>
      <p>Please contact management if you have further questions.</p>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons">close</i>
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {};
</script>
